import { connect } from 'react-redux';

import { LayoutActions } from '../../store/layout/layout.actions';
import { AppState } from '../../store/store';

import { MenuButton as Presentation } from './menu-button.component';

export const MenuButton = connect(
  (state: AppState) => ({
    open: state.layout.navbar,
  }),
  (dispatch) => ({
    toggleMenu: () => { dispatch(LayoutActions.toggleNavbar()); },
  }),
)(Presentation);
